
function SmsMaster() {
    return (
        <div class="page-content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-xxl-12">
                        <div class="card">
                            <div class="card-body">
                                <h5>Whatsapp Setup</h5>
                                <br />
                                <div class="live-preview">
                                    <form action="javascript:void(0);">
                                        <div class="row">

                                            <div class="col-md-6">
                                                <div >
                                                    <label for="customername-field" class="form-label">Whats App Number</label>
                                                    <input id="customername-field" class="form-control" placeholder="Enter Whats App Number" type="text" />
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div >
                                                    <label for="customername-field" class="form-label">Whats App Link</label>
                                                    <input id="customername-field" class="form-control" placeholder="Enter Whats App Link"
                                                        type="text" />
                                                </div>
                                            </div>

                                            <div class="col-md-6">
                                                <div >
                                                    <label for="customername-field" class="form-label">Body</label>
                                                    <input id="customername-field" class="form-control" placeholder="Enter Body" type="text" />
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div >
                                                    <label for="customername-field" class="form-label">Header</label>
                                                    <input id="customername-field" class="form-control" placeholder="Enter Header"
                                                        type="text" />
                                                </div>
                                            </div>
                                            <div class="col-lg-12"><br/></div>
                                            <div class="col-lg-12">
                                                <div class="text-end">
                                                    <button type="submit" class="btn btn-primary">Save</button>
                                                </div>
                                            </div>
                                        </div>

                                    </form>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SmsMaster;
